import PricingModel from "./pricingModel.js"

export default class ClubView {
	id = null
	
	ukraAffiliated = false

	acronym = null
	name = null
	url = null
	logoUrl = null
	notes = null

	coords = { lat: 0, lng: 0 }
	pricing = new PricingModel()

	calendars = {}

	constructor()
	{
	}

}